import { render, staticRenderFns } from "./charge-list.vue?vue&type=template&id=532e0cac"
import script from "./charge-list.vue?vue&type=script&lang=js"
export * from "./charge-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports